<template>
    <div class="login-messages" role="status" aria-live="polite">
        <div v-if="error" class="login-error">{{ error }}</div>
        <div v-if="notice" class="login-notice">{{ notice }}</div>
    </div>
</template>

<script>
// Errors and notices are rendered together, in the same place on every step of
// the sign-in flow, so a confirmation is never styled as a failure and a failure
// is never left off screen.
export default {
    name: "LoginMessages",

    props: {
        error: { type: String, default: "" },
        notice: { type: String, default: "" },
    },
};
</script>

<style scoped>
.login-messages {
    display: grid;
    gap: 6px;
    margin: 14px 0;
    min-height: 14px;
}

.login-error {
    color: #da222e;
    font-size: 14px;
}

.login-notice {
    background: #eef4fc;
    border-radius: 8px;
    color: #2f4a6d;
    font-size: 14px;
    padding: 8px 12px;
}
</style>
